// extracted by mini-css-extract-plugin
module.exports = {"button":"e_6g","inner":"e_7g","innerText":"e_8g"};